import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'normalize.css'
import http from './until/axios'
import ajax from './until/ajax'
import ajaxconfig from './until/ajaxconfig'
import AJcon from './until/config'
import ports from './until/api'
import { Icon } from 'mand-mobile'
import VueWechatTitle from 'vue-wechat-title'
import moment from 'moment'
import VueScroller from 'vue-scroller'
import Distpicker from 'v-distpicker'
Vue.use(VueWechatTitle)
Vue.component(Icon.name, Icon)
Vue.config.productionTip = false
Vue.prototype.http = http
Vue.prototype.ajax = ajax
Vue.prototype.ajaxconfig = ajaxconfig
Vue.prototype.ajcon = AJcon
Vue.prototype.ports = ports // 接口API
Vue.use(VueScroller)
Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.component('v-distpicker', Distpicker)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
